import {
  ICreatePermissionRequest,
  IDeletePermissionRequest,
  IGetAllPermissionsRequest,
  IUpdatePermissionRequest,
} from '../../types/api/request/permissionsrequest';
import {
  ICreatePermissionResponse,
  IGetAllPermissionsResponse,
} from '../../types/api/response/permissionsresponse';
import axiosClient from '../axiosClient';
import { PermissionsEndpoints } from '../endpoints/permissions';

export const PermissionsService = {
  async getAllPermissions(
    payload?: IGetAllPermissionsRequest,
  ): Promise<IGetAllPermissionsResponse> {
    const params = payload ? `?page=${payload?.page}&size=${payload?.size}` : ``;
    const res = await axiosClient.get<IGetAllPermissionsResponse>(
      `${PermissionsEndpoints.GET_ALL_PERMISSIONS}${params}`,
    );

    return res.data;
  },

  async createPermission(payload: ICreatePermissionRequest): Promise<ICreatePermissionResponse> {
    const res = await axiosClient.post<ICreatePermissionResponse>(
      `${PermissionsEndpoints.CREATE_PERMISSION}`,
      payload,
    );

    return res.data;
  },

  async updatePermission(payload: IUpdatePermissionRequest): Promise<ICreatePermissionResponse> {
    const res = await axiosClient.put<ICreatePermissionResponse>(
      PermissionsEndpoints.UPDATE_PERMISSION,
      payload,
    );
    return res.data;
  },

  async deletePermission(id: number): Promise<void> {
    const res = await axiosClient.delete(PermissionsEndpoints.DELETE_PERMISSION, {
      data: { id },
    });

    return res.data;
  },
};
